module.exports = __webpack_public_path__ + "img/2_2-finanziario-torre-2.fc33a3d6.png";